import {
  InternalServerError,
  NotFoundError,
  UnauthorizedError,
} from '@api/utils/throwError'
import React from 'react'
import { Navigate } from 'react-router-dom'

interface Props {
  error?: Error
}
const GlobalErrorFallBack = ({ error }: Props) => {
  let render = null
  ;(function () {
    switch (error?.constructor) {
      case UnauthorizedError:
        render = <Navigate to="/login?expire" replace={true} />
        break
      case NotFoundError:
        render = <div>404 Error</div>
        break
      case InternalServerError:
        render = <div>서버측 오류 in Global</div>
        break
    }
  })()
  return <>{render}</>
}

export default GlobalErrorFallBack
